import request from '@/utils/request'

export const contractActions = [
  { key: 'append', label: '追加', title: '追加保证金', icon: 'el-icon-circle-plus-outline' },
  { key: 'expand', label: '扩大', title: '扩大合约', icon: 'el-icon-full-screen' },
  { key: 'profit', label: '提盈', title: '合约提盈', icon: 'el-icon-wallet' },
  { key: 'settle', label: '结算', title: '合约结算', icon: 'el-icon-switch-button' },
  { key: 'renew', label: '续期', title: '合约续期', icon: 'el-icon-refresh' }
]

// Same methods and payloads as H5; only the application prefix is vexe.
export function contractOperation(market, action, id, amount, preview = false, send = request) {
  if (!['cn', 'hk', 'us'].includes(market) || !contractActions.some(item => item.key === action) || !Number(id)) throw new Error('请选择有效合约')
  const hk = market === 'hk' || market === 'us'
  const name = hk && action === 'profit' ? 'withdrawProfit' : action
  const method = preview && !hk && action !== 'renew' ? 'get' : 'post'
  const data = hk ? { contract_id: id } : { consult_id: id }
  if (!preview && ['append', 'expand', 'profit'].includes(action)) {
    if (!/^\d+(\.\d{1,2})?$/.test(String(amount)) || Number(amount) <= 0) throw new Error('请输入有效金额，最多两位小数')
    data[hk && action === 'append' ? 'append_price' : hk && action === 'expand' ? 'expand_price' : 'price'] = amount
  }
  if (!preview && action === 'renew') {
    if (!hk) data.contract_id = id
    data.expand_price = ''
  }
  return send({ url: `vexe/v1/${hk ? 'contract' : 'consult'}/${name}${preview ? 'Info' : ''}`, method, [method === 'get' ? 'params' : 'data']: data })
}

// H5's expansion estimate; the backend remains authoritative for fees/deductions.
export function expansionEstimate(info, amount) {
  const detail = info.detail || {}, deposit = Number(amount || 0) * Number(detail.multiple || 0)
  const base = deposit * Number(detail.ratio || 0) / 100, days = Number(info.dayTime || 0)
  const interest = Number((Number(detail.mode) === 1 ? base * (days <= 1 ? 1 : 2) : Number(detail.mode) === 2 ? base / 7 * days : Number(detail.mode) === 3 ? base / 30 * days : 0).toFixed(2))
  const rebate = Number((base * (1 - Number(info.user_interest_rebate_lever == null ? 100 : info.user_interest_rebate_lever) / 100)).toFixed(3))
  const payable = Math.max(0, interest - rebate - Number(info.coupon || 0) - Number(info.blocked || 0))
  return { deposit, total: Number(detail.account_money || detail.trading_money || 0) + deposit + Number(amount || 0), interest, rebate, required: Number(amount || 0) + payable }
}
